import * as React from "react";
interface Props {}
interface State {}
export default class Dashboard extends React.Component<Props, State> {
  render() {
    return (
      '5 Haziran 2023 itibariyle "metabase" kullanımdan kaldırıldığı için veri grafikleri de panelden kaldırılmıştır.'
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.tsx